import React, {useEffect, useState} from "react"
import {Col, Row} from "react-bootstrap"
import SelectField from "../../../components/common/select-field/SelectField"
import {Controller, useForm} from "react-hook-form";
import "./goals.scss"
import ThemeModals from "../../../components/common/modals/theme-modals/ThemeModals"
import {GetQuaterlyTargets} from "../../../services/quaterly-targets-api.service";
import TargetBox from "./goal-box/TargetBox";
import {getMonthName, getQuarterlyMonthlyTargets, getWeeksInMonth, getWeekStartEnd} from "../../../utils/helper";
import TargetsSkeleton from "../../skeletons/goals/TargetSkeleton";
import AddMonthlyTargets from "./AddMonthlyTargets";
import AddWeeklyTargets from "./AddWeeklyTargets";
import AddQuaterlyTargets from "./AddQuaterlyTargets";
import BorderWrapper from "../../../components/dashboard/border-wrapper/BorderWrapper";
import {useUser} from "../../../providers/UserContext";
import {GetGoals} from "../../../services/goals";
import GoalsBox from "./goal-box/GoalsBox";
import AddAnnualGoals from "./AddAnnualGoals";
import AddAnnualBooks from "./AddBooks";

// Helper function to determine current quarter and month
const getCurrentQuarterAndMonth = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-indexed

    // Determine quarter based on current month
    let currentQuarter;
    if (currentMonth >= 1 && currentMonth <= 3) {
        currentQuarter = "1";
    } else if (currentMonth >= 4 && currentMonth <= 6) {
        currentQuarter = "2";
    } else if (currentMonth >= 7 && currentMonth <= 9) {
        currentQuarter = "3";
    } else {
        currentQuarter = "4";
    }

    // Convert month to string format used in the app
    const currentMonthStr = currentMonth.toString();

    return { currentQuarter, currentMonthStr };
};

export default function Quests() {
    // Get current quarter and month
    const { currentQuarter, currentMonthStr } = getCurrentQuarterAndMonth();

    const [showOtherGoals, setShowOtherGoals] = useState(false)
    const [monthOptions, setMonthOptions] = useState([])
    const [addQuarterTargets, setAddQuarterTargets] = useState(false);
    const [addMonthlyTargets, setAddMonthlyTargets] = useState(false);
    const [addWeeklyTargets, setAddWeeklyTargets] = useState(false);
    const [goalSelectedCategroy, setGoalSelectedCategory] = useState(1);
    const [goalData, setGoalData] = useState();
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectDefaultValue, setSelectDefaultValue] = useState(currentQuarter); // Use current quarter
    const { selectedYear, setSelectedYear } = useUser();
    const [quater, setQuater] = useState(currentQuarter); // Use current quarter
    const [targetLoader, setTargetLoader] = useState(true);
    const [listing, setListing] = useState(false)
    const [goal, setGoal] = useState();
    const [goalLoader, setGoalsLoader] = useState(true);
    const [updateGoals, setUpdateGoals] = useState(false);
    const [addGoal, setAddGoal] = useState(false);
    const [addBooks, setAddBooks] = useState(false);
    const [duplicateData, setDuplicateData] = useState(null);

    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch
    } = useForm({
        mode: "onChange",
        defaultValues: {
            quarter: currentQuarter,  // Set default to current quarter
            month: currentMonthStr    // Set default to current month
        }
    });


    const quarterSelect = [
        { value: "1", label: "Quarter 1" },
        { value: "2", label: "Quarter 2" },
        { value: "3", label: "Quarter 3" },
        { value: "4", label: "Quarter 4" }
    ];

    const quarterMonths = {
        "1": [
            { value: "1", label: "January" },
            { value: "2", label: "February" },
            { value: "3", label: "March" }
        ],
        "2": [
            { value: "4", label: "April" },
            { value: "5", label: "May" },
            { value: "6", label: "June" }
        ],
        "3": [
            { value: "7", label: "July" },
            { value: "8", label: "August" },
            { value: "9", label: "September" }
        ],
        "4": [
            { value: "10", label: "October" },
            { value: "11", label: "November" },
            { value: "12", label: "December" }
        ]
    };


    async function GetAllGoals() {
        setGoalsLoader(true); // ✅ Start Loader Before API Call
        try {
            const response = await GetGoals({ year: selectedYear });
            console.log(response?.data?.data, 'response');
            setGoal(response?.data?.data);
        } catch (error) {
            console.error("Error fetching goals:", error);
        } finally {
            setGoalsLoader(false); // ✅ Stop Loader After API Call Completes
        }
    }


    useEffect(()=>{
        GetAllGoals()
    },[updateGoals, selectedYear])

    function handleAddAnnualGoal() {
        setAddGoal(true)
        setGoalSelectedCategory(1)
    }

    // Handle target duplication by opening appropriate modal with pre-filled data
    function handleDuplicateTarget(targetData) {
        console.log('Duplicate target data:', targetData);
        
        setDuplicateData(targetData);
        
        // Determine which modal to open based on targetType
        if (targetData?.targetType === 'weekly') {
            console.log('Opening weekly modal for duplicate');
            setAddWeeklyTargets(true);
        } else if (targetData?.targetType === 'monthly') {
            console.log('Opening monthly modal for duplicate');
            setAddMonthlyTargets(true);
        } else if (targetData?.targetType === 'quarterly') {
            console.log('Opening quarterly modal for duplicate');
            setAddQuarterTargets(true);
        } else {
            console.log('Unknown target type:', targetData?.targetType);
        }
    }

    // Handle goal duplication by opening AddAnnualGoals modal with pre-filled data
    function handleDuplicateGoal(goalData) {
        console.log('Duplicate goal data:', goalData);
        
        setDuplicateData({
            ...goalData,
            targetType: 'goal'
        });
        
        console.log('Opening annual goals modal for duplicate');
        setAddGoal(true);
    }

    const selectedQuarter = watch("quarter");

    console.log(typeof selectedQuarter, selectedQuarter , 'first time select')

    useEffect(() => {
        if (quater !== selectedQuarter) {
            setQuater(selectedQuarter); // ✅ Prevents unnecessary state updates
        }
    }, [selectedQuarter]);

    const selectedMonth = watch("month");

    console.log(selectedMonth, typeof selectedMonth, 'selectedMonth')


    // Category List
    const categories = [
        { name: "All", value : "", img: ""  },
        { name: "Faith", value : "Faith", img: "https://s3.amazonaws.com/riseup-backend/VrX2HhpHowzA" },
        { name: "Family", value : "Family", img: "https://s3.amazonaws.com/riseup-backend/2E0z0JloaIKP" },
        { name: "Fitness", value : "Fitness", img: "https://s3.amazonaws.com/riseup-backend/KXGBI4jGBJcH" },
        { name: "Finance", value : "Finance", img: "https://s3.amazonaws.com/riseup-backend/ZmxcOFkt6NVx" }
    ];


    useEffect(() => {
        if (selectedQuarter) {
            const monthsForQuarter = quarterMonths[selectedQuarter] || [];
            setMonthOptions(monthsForQuarter);

            // Check if we need to set a specific month (like for current month)
            const shouldSetCurrentMonth = selectedQuarter === currentQuarter;

            // If we're in the current quarter, try to set the current month
            if (shouldSetCurrentMonth) {
                // Check if the current month is in this quarter
                const isCurrentMonthInQuarter = monthsForQuarter.some(
                    month => month.value === currentMonthStr
                );

                if (isCurrentMonthInQuarter) {
                    setValue("month", currentMonthStr, { shouldValidate: true });
                } else {
                    // If not in this quarter, fall back to first month of quarter
                    if (monthsForQuarter.length > 0) {
                        const firstMonthOfQuarter = monthsForQuarter[0].value;
                        setValue("month", firstMonthOfQuarter, { shouldValidate: true });
                    }
                }
            } else {
                // For other quarters, just set to first month
                if (monthsForQuarter.length > 0) {
                    const firstMonthOfQuarter = monthsForQuarter[0].value;
                    setValue("month", firstMonthOfQuarter, { shouldValidate: true });
                }
            }
        }
    }, [selectedQuarter, setValue, currentMonthStr, currentQuarter]);



    async function GetAllTargets() {
        setTargetLoader(true); // ✅ Start Loader Before API Call
        setGoalData(null); // Clear previous data

        try {
            const response = await GetQuaterlyTargets(quater, selectedYear, selectedCategory);
            console.log("API Response:", response?.data?.data);
            setGoalData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching Quests:", error);
        } finally {
            setTargetLoader(false); // ✅ Stop Loader After API Call Completes
        }
    }

    useEffect(() => {
        console.log("Updated Goal Data:", goalData?.data?.quarterly);
    }, [goalData]);

    useEffect(()=>{
        GetAllTargets()
    },[quater, selectedCategory,listing, selectedYear])



    const[monthlyDataArray,setMonthlyDataArray] = useState([]);

    useEffect(() => {
        if (goalData?.data?.monthly && Object.keys(goalData?.data?.monthly).length > 0) {
            // Reset monthlyDataArray first to avoid persisting old data
            setMonthlyDataArray([]);

            if (goalData.data.monthly[selectedMonth]) {
                const monthValue = goalData.data.monthly[selectedMonth];

                // Calculate the correct number of weeks based on the month and year
                const totalWeeks = getWeeksInMonth(parseInt(selectedMonth), parseInt(selectedYear));
                console.log(`Month ${selectedMonth}/${selectedYear} has ${totalWeeks} weeks`);

                const weeklyArray = Array.from({ length: totalWeeks }, (_, index) => {
                    const weekNumber = (index + 1).toString();
                    return {
                        weekNumber,
                        tasks: monthValue?.weekly?.[weekNumber] || [] // Ensure empty array for missing weeks
                    };
                });

                // Update state directly without setTimeout
                setMonthlyDataArray([
                    {
                        month: selectedMonth,
                        monthlyTargets: monthValue?.monthlyTargets || [],
                        weekly: weeklyArray
                    }
                ]);
            }
        } else {
            setMonthlyDataArray([]); // Ensure empty array if no data
        }
    }, [goalData, selectedMonth, selectedYear]);





    console.log("monthlyDataArray",monthlyDataArray)
    console.log("quarterSelect",quater)

    console.log("monthlyDataCheck",getQuarterlyMonthlyTargets(goalData?.data?.monthly, quater));

    // useEffect(() => {
    //     reset({ quarter: selectDefaultValue }); // ✅ Reset react-hook-form state correctly
    // }, [selectDefaultValue, reset]); // ✅ Depend on `selectDefaultValue` and `reset`


    return(
        <div>
            <div className="goals-section">
                <Row>
                    <Col md={12}>
                        <div className={'goals-tabs'}>
                            <ul>
                                {categories.map(category => (

                                    <li
                                        key={category.name}
                                        className={selectedCategory === category.value ? "active" : ""}
                                        onClick={() => setSelectedCategory(category.value)}
                                    >
                                        {category.img && (
                                            <span>
                                                <img src={category.img} alt={category.name} />
                                            </span>
                                        )}
                                        {category.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Col>
                </Row>
                <div className={'target-selects'}>
                    <div className={'goals-heading'}>
                        <h2>Annual Goals</h2>
                        <div className={'btns-wrapper'}>
                            <BorderWrapper radius={8} margin={1} padding={1}>
                                <span className={'btn'} onClick={()=>{setAddGoal(true)}}>+ Add Annual Goals</span>
                            </BorderWrapper>
                            <span>
                    </span>
                        </div>
                    </div>

                    <Row>
                        {
                            (selectedCategory === 'Faith' || selectedCategory == '') &&
                            <Col md={selectedCategory == '' ? 6 : 12}>
                                <GoalsBox
                                    GoalHeading="Faith Goals"
                                    GoalEmptyHeading="Add Faith Goals"
                                    GoalIcon="https://s3.amazonaws.com/riseup-backend/VrX2HhpHowzA"
                                    boxColor="#00E6A9"
                                    iconColor="#40C9A2"
                                    Color="#E5FFF9"
                                    backgroundColor="#40C9A205"
                                    onClick={handleAddAnnualGoal}
                                    data={goal?.data?.Faith}
                                    getListing={updateGoals}
                                    setGetListing={setUpdateGoals}
                                    onDuplicate={handleDuplicateGoal}
                                />
                            </Col>
                        }

                        {
                            (selectedCategory === 'Family'  || selectedCategory == '') &&
                            <Col md={selectedCategory == '' ? 6 : 12}>
                                <GoalsBox
                                    GoalHeading="Family Goals"
                                    GoalEmptyHeading="Add Family Goals"
                                    GoalIcon="https://s3.amazonaws.com/riseup-backend/2E0z0JloaIKP"
                                    boxColor="#FF5C5C"
                                    iconColor="#F95C59"
                                    Color="#FFE5E5"
                                    backgroundColor="#F95C5905"
                                    onClick={handleAddAnnualGoal}
                                    data={goal?.data?.Family}
                                    getListing={updateGoals}
                                    setGetListing={setUpdateGoals}
                                    onDuplicate={handleDuplicateGoal}
                                />
                            </Col>
                        }
                        {
                            (selectedCategory === 'Fitness'  || selectedCategory == '' ) &&
                            <Col md={selectedCategory == '' ? 6 : 12}>
                                <GoalsBox
                                    GoalHeading="Fitness Goals"
                                    GoalEmptyHeading="Add Fitness Goals"
                                    GoalIcon="https://s3.amazonaws.com/riseup-backend/KXGBI4jGBJcH"
                                    boxColor="#00B2FF"
                                    iconColor="#24B9C2"
                                    Color="#E5F7FF"
                                    backgroundColor="#24B9C205"
                                    onClick={handleAddAnnualGoal}
                                    data={goal?.data?.Fitness}
                                    getListing={updateGoals}
                                    setGetListing={setUpdateGoals}
                                    onDuplicate={handleDuplicateGoal}
                                />
                            </Col>
                        }
                        {
                            (selectedCategory === 'Finance'  || selectedCategory == '') &&
                            <Col md={selectedCategory == '' ? 6 : 12}>
                                <GoalsBox
                                    GoalHeading="Finance Goals"
                                    GoalEmptyHeading="Add Finance Goals"
                                    GoalIcon="https://s3.amazonaws.com/riseup-backend/ZmxcOFkt6NVx"
                                    boxColor="#FFB800"
                                    iconColor="#DCAB43"
                                    Color="#FFF8E5"
                                    backgroundColor="#DCAB4305"
                                    onClick={handleAddAnnualGoal}
                                    data={goal?.data?.Finance}
                                    getListing={updateGoals}
                                    setGetListing={setUpdateGoals}
                                    onDuplicate={handleDuplicateGoal}
                                />
                            </Col>
                        }

                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <div className={'target-heading mb-3'}>
                                <h2>Quarterly Quests</h2>
                                <div>
                                    <BorderWrapper radius={8} margin={1} padding={1}>
                                        <span className={'btn'} onClick={()=>{setAddQuarterTargets(true)}}>+ Add Quaterly Quests</span>
                                    </BorderWrapper>
                                </div>
                            </div>
                            <div className={"dfields"}>
                                <Controller
                                    name="quarter"
                                    defaultValue={selectDefaultValue}
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <SelectField
                                            showSearch={false}
                                            label={"Quarterly Quests"}
                                            defaultValue={selectDefaultValue}
                                            field={field}
                                            placeholder={"Select Quarter"}
                                            className={"required"}
                                            options={quarterSelect}
                                            fieldName={field.name}
                                            setValue={setValue}
                                        />
                                    )}
                                />
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className={'target-heading mb-3'}>
                                <h2>Weekly Quests</h2>
                                <div>
                                    <BorderWrapper radius={8} margin={1} padding={1}>
                                        <span className={'btn'} onClick={()=>{setAddWeeklyTargets(true)}}>+ Add Weekly Quests</span>
                                    </BorderWrapper>
                                </div>
                            </div>

                            <div className={"dfields"}>
                                <Controller
                                    name="month"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <SelectField
                                            showSearch={false}
                                            label={"Select Month"}
                                            field={{
                                                ...field,
                                            }}
                                            value={selectedMonth}
                                            placeholder={"Select Month"}
                                            className={"required"}
                                            options={monthOptions}
                                            fieldName={field.name}
                                            setValue={setValue}
                                            disabled={!selectedQuarter}
                                        />
                                    )}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className={'target-session'}>
                    {
                        targetLoader ?
                            <TargetsSkeleton/>
                            :
                            <Row>
                                <Col md={6}>
                                    {
                                        goalData?.data &&                                        <TargetBox
                                            GoalHeading={`Quarter ${selectedQuarter} Quests`}
                                            GoalEmptyHeading={`Add Quarter ${selectedQuarter} Quests`}
                                            boxColor="white"
                                            iconColor="white"
                                            Color="#F7E5FF"
                                            backgroundColor="#BBBBBB05"
                                            onClick={()=>{setAddQuarterTargets(true)}}
                                            data={goalData?.data?.quarterly || []}
                                            loader={targetLoader}
                                            getListing={listing}
                                            setGetListing={setListing}
                                            onTargetUpdate={() => setListing(prev => !prev)}
                                            onDuplicate={(targetData) => handleDuplicateTarget({
                                                ...targetData,
                                                quarter: selectedQuarter,
                                                targetType: 'quarterly'
                                            })}
                                        />
                                    }

                                    <div className={'target-heading mt-3 mb-3'}>
                                        <h2>Monthly Quests</h2>
                                        <div>
                                            <BorderWrapper radius={8} margin={1} padding={1}>
                                                <span className={'btn'} onClick={()=>{setAddMonthlyTargets(true)}}>+ Add Monthly Quests</span>
                                            </BorderWrapper>
                                        </div>
                                    </div>

                                    {
                                        goalData?.data?.monthly && getQuarterlyMonthlyTargets(goalData?.data?.monthly, quater)?.map((v,i)=>{
                                            return(
                                                <TargetBox
                                                    GoalHeading={`${getMonthName(v?.month)} Monthly Quests`}
                                                    GoalEmptyHeading={`Add ${getMonthName(v?.month)} Quests`}
                                                    boxColor="white"
                                                    iconColor="#00AEFF"
                                                    Color="#F7E5FF"
                                                    backgroundColor="#00AEFF05"
                                                    onClick={()=>{setAddMonthlyTargets(true)}}
                                                    data={v?.monthlyTargets || []}
                                                    loader={targetLoader}
                                                    getListing={listing}
                                                    setGetListing={setListing}
                                                    onTargetUpdate={() => setListing(prev => !prev)}
                                                    onDuplicate={(targetData) => handleDuplicateTarget({
                                                        ...targetData,
                                                        quarter: quater,
                                                        month: v?.month,
                                                        targetType: 'monthly'
                                                    })}
                                                />
                                            )
                                        })
                                    }


                                    {/*<TargetBox*/}
                                    {/*    GoalHeading="February Monthly Quests"*/}
                                    {/*    GoalEmptyHeading="Add February Target"*/}
                                    {/*    boxColor="white"*/}
                                    {/*    iconColor="#00AEFF"*/}

                                    {/*    Color="#F7E5FF"*/}
                                    {/*    backgroundColor="#00AEFF05"*/}
                                    {/*/>*/}
                                    {/*<TargetBox*/}
                                    {/*    GoalHeading="March Monthly Quests"*/}
                                    {/*    GoalEmptyHeading="Add March Target"*/}
                                    {/*    boxColor="white"*/}
                                    {/*    iconColor="#00AEFF"*/}
                                    {/*    Color="#F7E5FF"*/}
                                    {/*    backgroundColor="#00AEFF05"*/}
                                    {/*/>*/}
                                </Col>
                                <Col md={6}>
                                    {/*Work Here*/}
                                    {
                                        monthlyDataArray && monthlyDataArray.length > 0 && (
                                            <>
                                                {monthlyDataArray.flatMap((monthData, monthIndex) =>
                                                    monthData?.weekly?.map((weekData, weekIndex) => {
                                                        // Get week date range
                                                        const weekRange = getWeekStartEnd(
                                                            parseInt(monthData.month),
                                                            parseInt(weekData.weekNumber),
                                                            parseInt(selectedYear)
                                                        );

                                                        return (
                                                            <TargetBox
                                                                key={`${monthData.month}-${weekData.weekNumber}`}
                                                                GoalHeading={`Week of ${weekRange}`}
                                                                GoalEmptyHeading="No Weekly Quests"
                                                                boxColor="white"
                                                                iconColor="#DCAB43"
                                                                Color="#F7E5FF"
                                                                backgroundColor="#FFE20405"
                                                                data={weekData?.tasks?.length > 0 ? weekData.tasks : []}
                                                                loader={targetLoader}
                                                                onClick={() => setAddWeeklyTargets(true)}
                                                                getListing={listing}
                                                                setGetListing={setListing}
                                                                onTargetUpdate={() => setListing(prev => !prev)}
                                                                onDuplicate={(targetData) => handleDuplicateTarget({
                                                                    ...targetData,
                                                                    quarter: quater,
                                                                    month: monthData.month,
                                                                    weekNumber: weekData.weekNumber,
                                                                    targetType: 'weekly'
                                                                })}
                                                            />
                                                        );
                                                    })
                                                )}
                                            </>
                                        )
                                    }

                                    {/*<TargetBox*/}
                                    {/*    GoalHeading="Week of 1 / 3-1/10 (Mon-Sun)"*/}
                                    {/*    GoalEmptyHeading="Add 1st Week Target"*/}
                                    {/*    boxColor="white"*/}
                                    {/*    iconColor="#DCAB43"*/}
                                    {/*    Color="#F7E5FF"*/}
                                    {/*    backgroundColor="#FFE20405"*/}
                                    {/*/>*/}
                                    {/*<TargetBox*/}
                                    {/*    GoalHeading="Week of 1 / 3-1/10 (Mon-Sun)"*/}
                                    {/*    GoalEmptyHeading="Add 1st Week Target"*/}
                                    {/*    boxColor="white"*/}
                                    {/*    iconColor="#DCAB43"*/}
                                    {/*    Color="#F7E5FF"*/}
                                    {/*    backgroundColor="#FFE20405"*/}
                                    {/*/>*/}
                                    {/*<TargetBox*/}
                                    {/*    GoalHeading="Week of 1 / 3-1/10 (Mon-Sun)"*/}
                                    {/*    GoalEmptyHeading="Add 1st Week Target"*/}
                                    {/*    boxColor="white"*/}
                                    {/*    iconColor="#DCAB43"*/}
                                    {/*    Color="#F7E5FF"*/}
                                    {/*    backgroundColor="#FFE20405"*/}
                                    {/*/>*/}
                                    {/*<TargetBox*/}
                                    {/*    GoalHeading="Week of 1 / 3-1/10 (Mon-Sun)"*/}
                                    {/*    GoalEmptyHeading="Add 1st Week Target"*/}
                                    {/*    boxColor="white"*/}
                                    {/*    iconColor="#DCAB43"*/}
                                    {/*    Color="#F7E5FF"*/}
                                    {/*    backgroundColor="#FFE20405"*/}
                                    {/*/>*/}
                                </Col>
                            </Row>
                    }
                </div>


                <div className={'mt-4'}>
                    <Row>
                        <Col md={6}>
                            <GoalsBox
                                GoalHeading="Other Goals"
                                GoalEmptyHeading="Add Others Goals"
                                boxColor="white"
                                iconColor="white"
                                Color="#F7E5FF"
                                backgroundColor="#BBBBBB05"
                                onClick={handleAddAnnualGoal}
                                getListing={updateGoals}
                                setGetListing={setUpdateGoals}
                                data={goal?.data?.Others}
                                onDuplicate={handleDuplicateGoal}
                                addBtn={
                                    <div className={'btns-wrapper'}>
                                        <BorderWrapper radius={8} margin={1} padding={1}>
                                            <p className={'btn mb-0'} style={{background: '#212121', color: 'white', borderRadius: '8px'}} onClick={()=>{setAddGoal(true)}}>+ Add Other Goals</p>
                                        </BorderWrapper>
                                    </div>
                                }
                            />
                        </Col>

                        <Col md={6}>
                            <GoalsBox
                                GoalHeading="Books I've Read"
                                GoalEmptyHeading="Add Books Goals"
                                boxColor="white"
                                iconColor="#FF0095"
                                Color="#F7E5FF"
                                backgroundColor="#FF009505"
                                onClick={handleAddAnnualGoal}
                                data={goal?.data?.Books}
                                getListing={updateGoals}
                                setGetListing={setUpdateGoals}
                                onDuplicate={handleDuplicateGoal}
                                addBtn={
                                    <div className={'btns-wrapper'}>
                                        <BorderWrapper radius={8} margin={1} padding={1}>
                                            <p className={'btn mb-0'} style={{background: '#212121', color: 'white', borderRadius: '8px'}} onClick={()=>{setAddGoal(true)}}>+ Add Books</p>
                                        </BorderWrapper>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </div>



            </div>

            <ThemeModals
                open={addQuarterTargets}
                close={() => {
                    setAddQuarterTargets(false);
                    setDuplicateData(null); // Clear duplicate data when modal closes
                }}
                title={duplicateData ? "Duplicate Quarterly Quest" : "Add Quarterly Quests"} // Each item in its own div
                content={
                    <AddQuaterlyTargets
                        selectedQuarter={selectedQuarter}
                        close={() => {
                            setAddQuarterTargets(false);
                            setDuplicateData(null); // Clear duplicate data when modal closes
                        }}
                        selectedCategory={selectedCategory}
                        getListing={listing}
                        setGetListing={setListing}
                        year={selectedYear}
                        duplicateData={duplicateData}
                    />
                }
            />
            <ThemeModals
                open={addMonthlyTargets}
                close={() => {
                    setAddMonthlyTargets(false);
                    setDuplicateData(null); // Clear duplicate data when modal closes
                }}
                title={duplicateData ? "Duplicate Monthly Quest" : "Add Monthly Quests"} // Each item in its own div
                content={
                    <AddMonthlyTargets
                        defaultSelectedQuarter={selectedQuarter}
                        selectedMonth={selectedMonth}
                        monthOptions={monthOptions}
                        selectedCategory={selectedCategory}
                        close={() => {
                            setAddMonthlyTargets(false);
                            setDuplicateData(null); // Clear duplicate data when modal closes
                        }}
                        getListing={listing}
                        setGetListing={setListing}
                        year={selectedYear}
                        duplicateData={duplicateData}
                    />
                }
            />
            <ThemeModals
                open={addWeeklyTargets}
                close={() => {
                    setAddWeeklyTargets(false);
                    setDuplicateData(null); // Clear duplicate data when modal closes
                }}
                title={duplicateData ? "Duplicate Weekly Quest" : "Add Weekly Quests"} // Each item in its own div
                content={
                    <AddWeeklyTargets
                        selectedMonth={selectedMonth}
                        quarter={quater}
                        monthOptions={monthOptions}
                        weekOptions={monthlyDataArray}
                        selectedCategory={selectedCategory}
                        close={() => {
                            setAddWeeklyTargets(false);
                            setDuplicateData(null); // Clear duplicate data when modal closes
                        }}
                        getListing={listing}
                        setGetListing={setListing}
                        year={selectedYear}
                        setValuee={setValue}
                        duplicateData={duplicateData}
                    />
                }
            />
            <ThemeModals
                open={addGoal}
                close={() => {
                    setAddGoal(false);
                    setDuplicateData(null); // Clear duplicate data when modal closes
                }}
                title={duplicateData && duplicateData.targetType === 'goal' ? "Duplicate Annual Goal" : "Add Annual Goals"} // Each item in its own div
                content={
                    <AddAnnualGoals
                        close={() => {
                            setAddGoal(false);
                            setDuplicateData(null); // Clear duplicate data when modal closes
                        }}
                        goalSelectedCategroy={goalSelectedCategroy}
                        setGoalSelectedCategory={setGoalSelectedCategory}
                        updateGoals={updateGoals}
                        setUpdateGoals={setUpdateGoals}
                        duplicateData={duplicateData && duplicateData.targetType === 'goal' ? duplicateData : null}
                        year={selectedYear}
                    />
                }
            />
            <ThemeModals
                open={addBooks}
                close={setAddBooks}
                title={"Add Books"} // Each item in its own div
                content={
                    <AddAnnualBooks
                        close={setAddBooks}
                        year={selectedYear}
                        updateGoals={listing}
                        setUpdateGoals={setListing}

                    />
                }
            />
        </div>
    )
}
